import { render, staticRenderFns } from "./quotes-tab.vue?vue&type=template&id=60fea5b9&scoped=true&"
import script from "./quotes-tab.vue?vue&type=script&lang=js&"
export * from "./quotes-tab.vue?vue&type=script&lang=js&"
import style0 from "./quotes-tab.vue?vue&type=style&index=0&id=60fea5b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fea5b9",
  null
  
)

export default component.exports